import {
	downloadCompaniesStat,
	downloadCompanyStat,
	downloadTotalStat,
	getAppsStatsByDateAndStore,
	getCompaniesStatsByDate,
	getCompanyStatsByDate,
	getSalesPointStatsByDate,
	getTotalStatsByDate,
	updateCommentsByOperatorTotalReportCsv,
	updateCommentsByTotalReportCsv,
} from '../helpers/statService';
import {checkError, closeAlert, receiveErrorAlert} from './commonsActions';
/*
 * action types
 */

export const FETCH_COMPANIES_STATS_BEGIN   = 'FETCH_COMPANIES_STATS_BEGIN';
export const FETCH_COMPANIES_STATS_SUCCESS = 'FETCH_COMPANIES_STATS_SUCCESS';
export const FETCH_COMPANIES_STATS_ERROR = 'FETCH_COMPANIES_STATS_ERROR';
export const FETCH_FILTERED_COMPANIES_STATS = 'FETCH_FILTERED_COMPANIES_STATS';

export const FETCH_COMPANY_STATS_BEGIN   = 'FETCH_COMPANY_STATS_BEGIN';
export const FETCH_COMPANY_STATS_SUCCESS = 'FETCH_COMPANY_STATS_SUCCESS';
export const FETCH_COMPANY_STATS_ERROR = 'FETCH_COMPANIY_STATS_ERROR';
export const FETCH_FILTERED_COMPANY_STATS = 'FETCH_FILTERED_COMPANY_STATS';

export const FETCH_STORE_STATS_BEGIN   = 'FETCH_STORE_STATS_BEGIN';
export const FETCH_STORE_STATS_SUCCESS = 'FETCH_STORE_STATS_SUCCESS';
export const FETCH_STORE_STATS_ERROR = 'FETCH_STORE_STATS_ERROR';
export const FETCH_FILTERED_STORE_STATS = 'FETCH_FILTERED_STORE_STATS';

export const FETCH_TOTAL_STATS_BEGIN   = 'FETCH_TOTAL_STATS_BEGIN';
export const FETCH_TOTAL_STATS_SUCCESS = 'FETCH_TOTAL_STATS_SUCCESS';
export const FETCH_TOTAL_STATS_ERROR = 'FETCH_TOTAL_STATS_ERROR';
export const FETCH_FILTERED_TOTAL_STATS = 'FETCH_FILTERED_TOTAL_STATS';

export const FETCH_APPS_STATS_BEGIN = 'FETCH_APPS_STATS_BEGIN';
export const FETCH_APPS_STATS_SUCCESS = 'FETCH_APPS_STATS_SUCCESS';
export const FETCH_APPS_STATS_ERROR = 'FETCH_APPS_STATS_ERROR';
export const FETCH_FILTERED_APPS_STATS = 'FETCH_FILTERED_APPS_STATS';

/*
 * action creators
 */

export const fetchStatsBegin = () => ({
	type: FETCH_COMPANIES_STATS_BEGIN
});

export const fetchStatsSuccess = stats => ({
	type: FETCH_COMPANIES_STATS_SUCCESS,
	payload: {
		stats: stats.data && stats.data.byCompaniesReportDtos ? stats.data.byCompaniesReportDtos : [],
		// numberOfElements : users.numberOfElements,
		// totalElements: users.totalElements,
		// totalPages: users.totalPages
	}
});

export const fetchCompaniesStats = query => dispatch => {
	dispatch(fetchStatsBegin());
	return getCompaniesStatsByDate(query).then(res => {
		dispatch(fetchStatsSuccess(res));
		dispatch(filteringCompaniesStats());
		return res
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert('No data')); // error message
		setTimeout(() => {
			dispatch(closeAlert());
			dispatch({
				type: FETCH_COMPANIES_STATS_ERROR
			})
		}, 2000);

	})
};

export const filteringCompaniesStats = filterWord => (dispatch, getState) => {
	const state = getState();
	let filteredStats = null;
	if (filterWord) {
		filteredStats = state.companiesStatsReducer.stats.filter( stat =>
			stat.companyName.toLowerCase().indexOf(filterWord.toLowerCase()) !== -1);
	} else {
		filteredStats = state.companiesStatsReducer.stats;
	}

	dispatch({
		type: FETCH_FILTERED_COMPANIES_STATS,
		payload: {
			filteredStats: filteredStats
		}
	});
};

export const fetchCompanyStats = (companyId, query)=> dispatch => {
    dispatch({
        type: FETCH_COMPANY_STATS_BEGIN
    });
    return getCompanyStatsByDate(companyId, query).then(res => {
        dispatch({
            type: FETCH_COMPANY_STATS_SUCCESS,
            payload: {
                companyStats: res.data,
                storesStats: res.data.salesPointReports
            }
        });
        dispatch(filteringCompanyStats());
        return res
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert('No data')); // error message
        setTimeout(() => {
            dispatch(closeAlert());
            dispatch({
                type: FETCH_COMPANY_STATS_ERROR
            })
        }, 2000);

    })
};

export const filteringCompanyStats = filterWord => (dispatch, getState) => {
	const state = getState();
	let filteredCompanyStats = null;
	if (filterWord) {
		filteredCompanyStats = state.companyStatsReducer.storesStats.filter( store =>
            store.salesPointName.toLowerCase().indexOf(filterWord.toLowerCase()) != -1);
	} else {
		filteredCompanyStats = state.companyStatsReducer.storesStats;
	}
	dispatch({
		type: FETCH_FILTERED_COMPANY_STATS,
		payload: {
			filteredCompanyStats: filteredCompanyStats
		}
	});
};

export const fetchStoreStats = (storeId, query)=> dispatch => {
    dispatch({
        type: FETCH_STORE_STATS_BEGIN
    });
    return getSalesPointStatsByDate(storeId, query).then(res => {
        dispatch({
            type: FETCH_STORE_STATS_SUCCESS,
            payload: {
                storeStats: res.data,
                uploadReports: res.data.uploadReports
            }
        });
        dispatch(filteringStoreStats());
        return res
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert('No data')); // error message
        setTimeout(() => {
            dispatch(closeAlert());
            dispatch({
                type: FETCH_STORE_STATS_ERROR
            })
        }, 2000);

    })
};

export const filteringStoreStats = filterWord => (dispatch, getState) => {
	const state = getState();
	let filteredStoreStats = null;
	if (filterWord) {
		filteredStoreStats = state.storeStatsReducer.uploadReports.filter( report =>
			report.phoneModel.toLowerCase().indexOf(filterWord.toLowerCase()) !== -1);
	} else {
		filteredStoreStats = state.storeStatsReducer.uploadReports;
	}

	dispatch({
		type: FETCH_FILTERED_STORE_STATS,
		payload: {
			filteredStoreStats: filteredStoreStats
		}
	});
};

export const fetchAppsStats = (query)=> dispatch => {
	dispatch({
		type: FETCH_APPS_STATS_BEGIN
	});
	return getAppsStatsByDateAndStore(query).then(res => {
		dispatch({
			type: FETCH_APPS_STATS_SUCCESS,
			payload: {
				appsStats: res.data,
				numberOfElements : res.numberOfElements,
				totalElements: res.totalElements,
				totalPages: res.totalPages
			}
		});
		return res
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert('No data')); // error message
		setTimeout(() => {
			dispatch(closeAlert());
			dispatch({
				type: FETCH_APPS_STATS_ERROR
			})
		}, 2000);

	})
};


export const fetchTotalStats = (query)=> dispatch => {
	dispatch({
		type: FETCH_TOTAL_STATS_BEGIN
	});
	return getTotalStatsByDate(query).then(res => {
		dispatch({
			type: FETCH_TOTAL_STATS_SUCCESS,
			payload: {
				totalStats: res.data,
				numberOfElements : res.numberOfElements,
				totalElements: res.totalElements,
				totalPages: res.totalPages
			}
		});
		return res
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert('No data')); // error message
		setTimeout(() => {
			dispatch(closeAlert());
			dispatch({
				type: FETCH_TOTAL_STATS_ERROR
			})
		}, 2000);

	})
};

export const downloadCompanyCsvStat = query => dispatch => {
	return downloadCompanyStat(query).then(res => {
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const downloadCompaniesCsvStat = query => dispatch => {
	return downloadCompaniesStat(query).then(res => {
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const downloadTotalCsvStat = query => dispatch => {
	return downloadTotalStat(query).then(res => {
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const updateCommentsByTotalReportCsvFile = file => dispatch =>{
	const data = new FormData();
	data.append('file', file);
	return updateCommentsByTotalReportCsv(data).then(res => {
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const updateCommentsByOperatorTotalReportCsvFile = file => dispatch =>{
	const data = new FormData();
	data.append('file', file);
	return updateCommentsByOperatorTotalReportCsv(data).then(res => {
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};



// WEBPACK FOOTER //
// ./src/actions/statsActions.js